import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);
const ConfigCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const reload = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      setUser(false);
    }
  }, []);
  useEffect(() => { reload(); }, [reload]);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  };
  return <AuthCtx.Provider value={{ user, setUser, reload, logout }}>{children}</AuthCtx.Provider>;
}

export function ConfigProvider({ children }) {
  const [config, setConfig] = useState({ categories: [], content: {}, whatsapp: "", sms_test_mode: false });
  const reload = useCallback(async () => {
    const { data } = await api.get("/public/config");
    setConfig(data);
  }, []);
  useEffect(() => { reload().catch(() => {}); }, [reload]);
  return <ConfigCtx.Provider value={{ ...config, reload }}>{children}</ConfigCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const useConfig = () => useContext(ConfigCtx);
export const homeFor = (u) => (u.role === "admin" ? "/admin" : u.role === "dealer" ? "/dealer" : "/broker");
export const can = (u, perm) => !!u && u.role === "admin" && (u.is_super || u.permissions?.includes(perm));
